import { Button, Icon } from '@chakra-ui/react';
import { Table } from '@tanstack/react-table';
import { BiReset } from 'react-icons/bi';

export const ResetTableFilters = <T,>({ table, onReset }: { table: Table<T>; onReset?: () => void }) => {
    return (
        <Button leftIcon={<Icon as={BiReset} />} size="sm" onClick={() => (onReset ? onReset() : table.reset())}>
            Reset filters
        </Button>
    );
};
